import { render, staticRenderFns } from "./extendedAttributes.vue?vue&type=template&id=42f160ac&"
import script from "./extendedAttributes.vue?vue&type=script&lang=js&"
export * from "./extendedAttributes.vue?vue&type=script&lang=js&"
import style0 from "./extendedAttributes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports